<template>
  <validation-observer ref="observer">
    <base-dialog-full title="PDF"
                      :show="true"
                      :tempSaveBtn="false"
                      @close="close">
      <div style="background-color:#fff">
      <!-- 附件 -->
      <v-tabs grow
              color="cyan"
              dark
              icons-and-text
              hide-slider
              v-model="tabAecActive"
              class="tab-sec-style">
        <!-- 遠距不顯示 -->
        <v-tab href="#tab-1" v-if="'R' !== polInsureType"
               :ripple=false>
          <v-icon v-if="isDoneTab1"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span>要保書文件</span>
        </v-tab>
        <v-tab href="#tab-2"
               :ripple=false>
          <v-icon v-if="isDoneTab2"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span>書面分析報告</span>
        </v-tab>
        <!-- 遠距不顯示 -->
        <v-tab href="#tab-3"  v-if="'R' !== polInsureType"
               :ripple=false>
          <v-icon v-if="isDoneTab3"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span>個資同意書</span>
        </v-tab>
        <v-tab href="#tab-4"
               :ripple=false>
          <v-icon v-if="isDoneTab4"
                  color="primary"
                  class="mr-2">done</v-icon>
          <span>附件上傳</span>
        </v-tab>
        <v-tabs-items touchless>
        <v-tab-item value="tab-1"
                    lazy>
            <scroll-view id="annex-Statement" style="height:auto">
              <v-layout ref="getHightA01">
                <pdf-viewer-with-image  :cfgRatio="pdfViewerRatio01" :base64Data="annexDescA01" :stretch="false" :usedMaskLoading="true"></pdf-viewer-with-image>
              </v-layout>
            </scroll-view>
        </v-tab-item>

        <v-tab-item value="tab-2"
                    lazy>
              <v-layout ref="getHightB02"  style="height:auto">
                <pdf-viewer-with-image :cfgRatio="pdfViewerRatio" :base64Data="annexDescB02" :stretch="true" :usedMaskLoading="true"></pdf-viewer-with-image>
              </v-layout>
                  </v-tab-item>
        <v-tab-item value="tab-3"
                    lazy>
              <v-layout ref="getHightB03"  style="height:auto">
                <pdf-viewer-with-image :cfgRatio="pdfViewerRatio" :base64Data="annexDescB03" :stretch="true" :usedMaskLoading="true"></pdf-viewer-with-image>
              </v-layout>
        </v-tab-item>
        <v-tab-item value="tab-4"
                    lazy>
          <base-container  title="附件上傳" >
            <v-data-table :items="item.polfItem"
                          rows-per-page-text="顯示資料筆數"
                          no-data-text=""
                          class="elevation-1"
                          hide-actions>
              <template v-slot:headers>
                <tr>
                  <th class="pa-2">證明文件項目</th>
                  <th class="pa-2">證明文件上傳</th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                  <td style="width:30%;">{{props.item.fileTypeName}}</td>
                  <td style="width:70%;">
                    <div class="files">
                        <a @click="loadShowFileIdx(props.index)">{{ props.item.fileName }}</a>
                        <base-dialog-full title="上傳檔案檢視"
                                          :show="showfileIdx == props.index"
                                          :tempSaveBtn="false"
                                          @close="closeShowFileIdx(props.index)">
                          <img :src="getImgSrc(props.item)" width="70%" v-if="props.item.fileName.indexOf('.pdf') == -1" />
                          <v-layout v-scroll:#collective-Statement="onScroll" v-if="props.item.fileName.indexOf('.pdf') != -1" >
                            <pdf-viewer-with-image :base64Data="getPdfSrc(props.item)" />
                          </v-layout>
                        </base-dialog-full>
                    </div>

                  </td>
                </tr>
            </template>
            </v-data-table>

          </base-container>

        </v-tab-item>
        </v-tabs-items>
      </v-tabs>

    </div>
    </base-dialog-full>
  </validation-observer>
</template>
<script>
import ScrollView from '@/components/Base/ScrollView'
//fix by Issue #53784
import pdfViewerWithImage from '@/components/PDFViewer/PDFViewerWithImage.vue'
export default {
  name: 'preview-Pdf-Result',
  components: { ScrollView, pdfViewerWithImage },//fix by Issue #53784
  props: {
    item: Object,
    polInsureType: String
  },
  data () {
    return {
      annexItem: {},
      tabAecActive: 'R' !== this.polInsureType ? 'tab-1' : 'tab2', // 行投顯示第一頁，遠距顯示第二頁
      isDoneTab1: true,
      isDoneTab2: true,
      isDoneTab3: true,
      isDoneTab4: true,
      annexDescA01: '', // 要保書文件
      annexDescB02: '', // 書面分析報告
      annexDescB03: '', // 個資同意書
      offsetTopA01: 0,
      offsetTopB02: 0,
      offsetTopB03: 0,

      showfileIdx: Number,
    }
  },
  watch: {
    annexItem: {
      handler (v) {
        if(v.A01){ // 要保書文件
          this.docTypeA01 = v.A01[0].contType
          this.annexDescA01 = v.A01[0].docContBase64
        }
        if(v.B03){  // 書面分析報告
          this.docTypeB02 = v.B03[0].contType
          this.annexDescB02 = v.B03[0].docContBase64
        }else if(v.B05){ // 遠距
          this.docTypeB02 = v.B05[0].contType
          this.annexDescB02 = v.B05[0].docContBase64
        }
        if(v.B02){ // 個資同意書 行投
          this.docTypeB03 = v.B02[0].contType
          this.annexDescB03 = v.B02[0].docContBase64
        }
      }
    }
  },
  computed: {
    is1024Size () {
      if (window.screen.width < 1366) {
        return true
      } else {
        return false
      }
    },
    pdfViewerRatio () {
      if (this.is1024Size) {
        return '0.93'
      } else {
        return '1.5'
      }
    },
    pdfViewerRatio01 () {
        return '1.5'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onScrollA01 (e) {
      this.offsetTopA01 = e.target.scrollTop
    },
    onScrollB02 (e) {
      this.offsetTopB02 = e.target.scrollTop
    },
    onScrollB03 (e) {
      this.offsetTopB03 = e.target.scrollTop
    },
    getImgSrc (file) {
      let base64 = file.fileCntBase64
      return 'data:image/jpeg;base64,' + base64
    },
    getPdfSrc (file) {
      let base64 = file.fileCntBase64
      // return 'data:application/pdf;base64,' + base64
      return base64
    },
    loadShowFileIdx (idx) {
      this.showfileIdx = idx
    },
    closeShowFileIdx (idx) {
      this.showfileIdx = -1
    },

    onGetBase64Str (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onUpdChgTmpFile (hasTmpFile) {
      let hasTmpFileObj = {
        hasTmpFile: hasTmpFile,
        fileType: this.fileType
      }
      this.$emit('chg-has-tmp', hasTmpFileObj)
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    }
  },
  created () {
    this.annexItem = { ...this.annexItem, ...this.item.annexItem }
  }
}
</script>
